import { render, staticRenderFns } from "./OrdersPage.vue?vue&type=template&id=13c11f5a&scoped=true"
import script from "./OrdersPage.vue?vue&type=script&lang=js"
export * from "./OrdersPage.vue?vue&type=script&lang=js"
import style0 from "./OrdersPage.vue?vue&type=style&index=0&id=13c11f5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c11f5a",
  null
  
)

export default component.exports